var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heading-special"},[_c('div',{staticClass:"title-line"}),_vm._v(" "),_c('div',{staticClass:"title-bar-block low",style:({ width: _vm.barWidth })},[_c('div',{staticClass:"title-bar"})]),_vm._v(" "),_c('div',{ref:"titleBlockContainer",staticClass:"container title-block-container"},[_c('div',{ref:"titleBlock",staticClass:"title-block low"},[_c('h1',{staticClass:"title"},[_vm._t("default")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./resources/js/components/motor-show/HeadingSpecial.vue?vue&type=template&id=bd2ff772&scoped=true&
// module id = null
// module chunks = 